<template>
    <nav class="previous-step__container">
        <button v-if="deepLinkData && deepLinkData.page === 'dealerSelect'" @click="backToTestDrive" class="previous-step__link">Back a step</button>
        <button v-else v-on:click="back" class="previous-step__link">Back a step</button>
    </nav>
</template>

<script>
import { mapState, mapGetters } from "vuex";

export default {
    name: "PreviousStep",
    computed: {
        ...mapState(["navigator", "deepLinkData"]),
        ...mapGetters(["currentStep"]),
    },
    methods: {
        back() {
            if (this.currentStep.previous) {
                this.$store.dispatch("navigatorStep", this.currentStep.previous);
            }
        },
        backToTestDrive(){
            window.location.href = `/${this.deepLinkData.brand}/book-a-test-drive`
        }
    },
};
</script>

<style lang="scss" scoped>
.previous-step {
    &__container {
        margin-top: 30px;
        margin-bottom: 30px;
        display: flex;

        @media (max-width: 767px) {
            justify-content: center;
        }
    }

    &__link {
        font-family: "Encode Sans";
        font-size: 15px;
        color: #0293d6;
        appearance: none;
        border: none;
        background-color: unset;
        padding: 0;

        &:hover {
            cursor: pointer;
        }

        &::before {
            display: inline-block;
            content: url("/images/link-icon.svg");
            width: 22px;
            height: 22px;
            transform-origin: center;
            transform: rotate(183deg) translateY(-5px);
            margin-right: 0.5rem;
        }
    }
}
</style>
